// @module NVT.MyRegisterColleague.MyRegisterColleague
define('NVT.MyRegisterColleague.MyRegisterColleague.View'
	,	[
		'nvt_myregistercolleague_myregistercolleague.tpl'
		
		,	'NVT.MyRegisterColleague.MyRegisterColleague.SS2Model'
		
		,	'Backbone'
	
		, 	'GlobalViews.Message.View'
	
		,	'GlobalViews.Confirmation.View'
	
		,	'NVT.MyRegisterColleague.MyRegisterColleague.View'
	
		,	'Profile.Model'
	
		,	'Utils'
	
		]
	, function (
			nvt_myregistercolleague_myregistercolleague_tpl
		
		,	MyRegisterColleagueSS2Model
		
		,	Backbone
	
		,   MessageView
	
		, 	GlobalViewsConfirmationView
	
		,	MyRegisterColleagueView
	
		,	ProfileModel
	
		,	Utils
	
	)
	{
		'use strict';
		var doyouwanttoaddmore = false;
	
		// @class NVT.MyRegisterColleague.MyRegisterColleague.View @extends Backbone.View
		return Backbone.View.extend({
	
			template: nvt_myregistercolleague_myregistercolleague_tpl
	
		,	initialize: function (options) {
				this.options = options;
				this.container = options.container;
				this.layout = this.container.getComponent('Layout');
				this.pdp = this.container.getComponent('PDP');
				var self = this;
			}
	
		,	events: {
				'submit form': 'saveForm',
				'keyup #mysearchCompany': 'searchAndGetListCompany',
				'keyup [data-input="mysearchCompany"]': 'searchAndGetListCompany',
				'click button[data-action="resetform"]': 'resetformclear',
				'click button[data-action="want-to-add-more-colleague"]': 'wantToAddMoreColleague',
				'click button[data-action="add-new-colleague"]': 'addNewColleague',
				'change [data-action="contact_list"]': 'getContactList',
				'change [data-action="company_contact_list"]': 'ContactListSearching',
				'click [data-action="selectregisterColleagueName"]': 'choiceRegisterColleagueName',
				'click button[data-action="add-new-colleague-wait-list"]': 'addNewColleagueWaitlist',
				'click button[data-action="add-new-colleague-isscrrequire"]': 'addNewColleagueisscrrequire',
				'click label[data-action="itemoption-wise-price"]': 'itemOptionWisePrice',
			}
	
		,	itemOptionWisePrice: function(e)
		{
			var self=this;
			var getmpo = e.currentTarget.dataset.mpo || '';
			if(getmpo)
			{
				var getfiltervalue = this.getmultiPriceOption.filter(function(price) {
					return price.internalid == getmpo
				})
	
				if(getfiltervalue && getfiltervalue.length > 0)
				{
					var convPriceMember = Utils.formatCurrency(getfiltervalue[0].memberprice,'');
					var convPriceNonMember = Utils.formatCurrency(getfiltervalue[0].nonmemberprice,'');
	
					jQuery("#getpriceLevel1Member").text(convPriceMember);
					jQuery("#getpriceLevel3nonMember").text(convPriceNonMember);
					jQuery(".priceonethree").css("display","block");
				}
				else{
					jQuery("#getpriceLevel1Member").text('');
					jQuery("#getpriceLevel3nonMember").text('');
					jQuery(".priceonethree").css("display","none");
				}		
			}
		}	
		
		,	choiceRegisterColleagueName : function(e)
			{
				var self = this;
				this.getcurrentindexval = e.currentTarget.value;
				if(this.getcurrentindexval == '2'){               
					jQuery(".choicerrgistercolleague input[name='registerColleagueName'][value="+this.getcurrentindexval+"]").prop("checked",true);
					jQuery(".contactlists").css("display",'block');
					jQuery('#in-modal-contact_list').val('');
	
					if(this.options.isgetnoneditblecontact === true)
					{
						jQuery('#in-modal-nus_ems_name').attr('readonly', true);
						jQuery('#in-modal-nus_job_title').attr('readonly', false);
						jQuery('#in-modal-nus_phone_no').attr('readonly', false);
						jQuery('#in-modal-nus_email_address').attr('readonly', true);
						jQuery('#in-modal-isgetnoneditblecontact').css("display","block");
					}
				}
	
				if(this.getcurrentindexval == '1'){               
					jQuery(".choicerrgistercolleague input[name='registerColleagueName'][value="+this.getcurrentindexval+"]").prop("checked",true);
					jQuery(".contactlists").css("display",'none');
					jQuery('#in-modal-nus_ems_name').val('');
					jQuery('#in-modal-nus_job_title').val('');
					jQuery('#in-modal-nus_phone_no').val('');
					jQuery('#in-modal-nus_email_address').val('');
					jQuery('#in-modal-contact_list').val('');				
	
					jQuery('#in-modal-nus_ems_name').attr('readonly', false);
					jQuery('#in-modal-nus_job_title').attr('readonly', false);
					jQuery('#in-modal-nus_phone_no').attr('readonly', false);
					jQuery('#in-modal-nus_email_address').attr('readonly', false);
					jQuery('#in-modal-isgetnoneditblecontact').css("display","none");
				}
			}
	
		,	getContactList : function(e)
			{	
				var self = this;
				var getid = this.$(e.currentTarget).val();
					jQuery('#in-modal-nus_ems_name').val('');
					jQuery('#in-modal-nus_job_title').val('')
					jQuery('#in-modal-nus_phone_no').val('')
					jQuery('#in-modal-nus_email_address').val('')
	
				if(getid)
				{				
					var model = new MyRegisterColleagueSS2Model();      
						model.fetch({async: false,data: {
						'getsearchkeyword': getid,
						'types':'contact',
						'getmethod':'ContactListSearching',
						'allowregother':self.options.pdp.item.custitem_nus_ems_regother,
						'allowaddguest':self.options.pdp.item.custitem_nus_ems_addguest,
					}})
					.done(function (getContactName) { 	
						if(getContactName.length > 0)
						{
							jQuery('#in-modal-nus_ems_name').val(getContactName[0].name);
							jQuery('#in-modal-nus_job_title').val(getContactName[0].getJobTitle)
							jQuery('#in-modal-nus_phone_no').val(getContactName[0].getPhoneNo)
							jQuery('#in-modal-nus_email_address').val(getContactName[0].getEmailAddress)
						}
					});				
				}
			}	
	
		,	wantToAddMoreColleague : function(e)
			{
				var self = this;		  	
				// self.resetformclear();
				// jQuery(".reg-add-to-disaply-multiple-event").css("display","none");
				// jQuery('.class-waitlist-confirmation-message').css('display','none');
				// jQuery(".reg-add-to-disaply").css("display","block");
	
				doyouwanttoaddmore = true;
				document.getElementsByName("surveyquestionans").value = '';
				jQuery("[data-dismiss=modal]").trigger({ type: "click" });
				setTimeout(function() {
					jQuery(".idptritwobtn").click();
				}, 500);
			}	
	
		,	addNewColleague : function(e)
			{			
				if(jQuery('.multiPriceOption').length !=0 && jQuery('input[name="multiPriceOption"]:checked').val() == undefined)
				{
					e.preventDefault();
					const getlay= this.options.container.layout;		
					const global_view_message = new MessageView({
						message: Utils.translate('Please select item option'),
						type: 'error',
						closable: true
					});					
	
					getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').css("display","block");
	
					setTimeout(function() {
						confirmation_message.fadeOut(3000);
					}, 5000);
	
					return false;
				}
				else if (this.layout) {
					
					var modalMessage = new MyRegisterColleagueView({ container: this.container,pdp: this.pdp.getItemInfo(),addNewColleague:'NewColleaguelist',title:'Register Colleague'  });
						modalMessage.modalClass ='modal-md';
						modalMessage.title = 'Register Participant'; //Colleague
						this.options.container.layout.showInModal(modalMessage);
					return false;
				}			
			}	
	
		,	addNewColleagueWaitlist : function(e)
		{			
			if(jQuery('.multiPriceOption').length !=0 && jQuery('input[name="multiPriceOption"]:checked').val() == undefined)
			{
				e.preventDefault();
				const getlay= this.options.container.layout;		
				const global_view_message = new MessageView({
					message: Utils.translate('Please select item option'),
					type: 'error',
					closable: true
				});					
	
				getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').html(global_view_message.render().$el.html());
				const confirmation_message = getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').css("display","block");
	
				setTimeout(function() {
					confirmation_message.fadeOut(3000);
				}, 5000);
	
				return false;
			}
			else if (this.layout) {
				
				var modalMessage = new MyRegisterColleagueView({ container: this.container,pdp: this.pdp.getItemInfo(),addNewColleague:'Waitlist',title:'Join Waitlist' });
					modalMessage.modalClass ='modal-md';
					modalMessage.title = 'Join Waitlist';
					this.options.container.layout.showInModal(modalMessage);
				return false;
			}			
		}	
	
	
		,	addNewColleagueisscrrequire : function(e)
		{			
			if(jQuery('.multiPriceOption').length !=0 && jQuery('input[name="multiPriceOption"]:checked').val() == undefined)
			{
				e.preventDefault();
				const getlay= this.options.container.layout;		
				const global_view_message = new MessageView({
					message: Utils.translate('Please select item option'),
					type: 'error',
					closable: true
				});					
	
				getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').html(global_view_message.render().$el.html());
				const confirmation_message = getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').css("display","block");
	
				setTimeout(function() {
					confirmation_message.fadeOut(3000);
				}, 5000);
	
				return false;
			}
			else if (this.layout) {
				var getnoneditblecontact =jQuery('input[name="multiPriceOption"]:checked').attr('noneditblecontact');
					getnoneditblecontact = getnoneditblecontact === 'true'
	
					if(jQuery('.multiPriceOption').length == 0 && jQuery('input[name="multiPriceOption"]:checked').val() == undefined)
					{
						getnoneditblecontact = this.pdp.getItemInfo().item.custitem_nus_noneditablecontact;
					}
	
				var modalMessage = new MyRegisterColleagueView({ container: this.container,pdp: this.pdp.getItemInfo(),addNewColleague:'scrrequire',title:'SCREENING', isgetnoneditblecontact:getnoneditblecontact });
					modalMessage.modalClass ='modal-md';
					modalMessage.title = 'SCREENING';
					this.options.container.layout.showInModal(modalMessage);
				return false;
			}			
		}	
	
		,	saveForm: function(e)
			{
				var self = this;
				var $form = this.$(e.target)
				,	form_data = $form.serializeObject();
					e.preventDefault();
				// var getmycomp = document.querySelector("#in-modal-searchCompany"  + " option[value='" + jQuery("#in-modal-mysearchCompany").val().trim() + "']");
				// 	getmycomp = getmycomp ? getmycomp.dataset.value : '';
				var getmycomp =	jQuery("#in-modal-mysearchCompany").val() ? jQuery("#in-modal-mysearchCompany").val() : '';
				self.profile = ProfileModel.getInstance();
				self.isperson = self.profile.get('isperson') === true;
				// if(getmycomp == '' && self.isperson == true)
				// {
				// 	getmycomp = document.querySelector("#in-modal-searchCompany"  + " option[data-value='" + self.profile.get('internalid') + "']");
				// 	getmycomp = getmycomp ? getmycomp.dataset.value : '';
				// }
				self.getorgID = getmycomp;
				if(form_data.mysearchCompany == '' || getmycomp == '')
				{
					const getlay= self.options.container.layout;		
					const global_view_message = new MessageView({
						message: Utils.translate('Please selected organisation list.'),
						type: 'error',
						closable: true
					});					
	
					getlay.$('[data-type="alert-placeholder-message-searchCompany"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-searchCompany"]').css("display","block");
	
					setTimeout(function() {
						confirmation_message.fadeOut(3000);
					}, 5000);
	
					return false;
				}
	
				if(form_data.contact_list == '' && form_data.registerColleagueName =="2")
				{
					const getlay= self.options.container.layout;		
					const global_view_message = new MessageView({
						message: Utils.translate('Please selected contact list.'),
						type: 'error',
						closable: true
					});					
	
					getlay.$('[data-type="alert-placeholder-message-contact_list"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-contact_list"]').css("display","block");
	
					setTimeout(function() {
						confirmation_message.fadeOut(3000);
					}, 5000);
	
					return false;
				}
	
				if(form_data.nus_ems_name == '')
				{
					const getlay= self.options.container.layout;		
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter contact name.'),
						type: 'error',
						closable: true
					});					
	
					getlay.$('[data-type="alert-placeholder-message-nus_ems_name"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_ems_name"]').css("display","block");
	
					setTimeout(function() {
						confirmation_message.fadeOut(3000);
					}, 5000);
	
					return false;
				}
	
				if(form_data.nus_job_title == '')
				{
					const getlay= self.options.container.layout;		
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter job title.'),
						type: 'error',
						closable: true
					});					
	
					getlay.$('[data-type="alert-placeholder-message-nus_job_title"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_job_title"]').css("display","block");
	
					setTimeout(function() {
						confirmation_message.fadeOut(3000);
					}, 5000);
	
					return false;
				}
	
				if(form_data.nus_phone_no == '' || form_data.nus_phone_no.length < 8)
				{
					const getlay= self.options.container.layout;		
					const global_view_message = new MessageView({
						message: Utils.translate('A phone number is required. Please enter at least 8 digits.'),
						type: 'error',
						closable: true
					});					
	
					getlay.$('[data-type="alert-placeholder-message-nus_phone_no"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_phone_no"]').css("display","block");
	
					setTimeout(function() {
						confirmation_message.fadeOut(3000);
					}, 5000);
	
					return false;
				}
	
				if(form_data.nus_email_address == '')
				{
					const getlay= self.options.container.layout;		
					const global_view_message = new MessageView({
						message: Utils.translate('The email address used for login is required.'),
						type: 'error',
						closable: true
					});					
	
					getlay.$('[data-type="alert-placeholder-message-nus_email_address"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_email_address"]').css("display","block");
	
					setTimeout(function() {
						confirmation_message.fadeOut(3000);
					}, 5000);
	
					return false;
				}
	
				// option -1
				// if(self.getAllQuestionList)
				// {
				// 	var surveyquesval = document.getElementsByName("surveyquestionans").value ;
				// 	var surveyquesvalInarry = surveyquesval ? Object.keys(surveyquesval) : [];
				// 	var getQuestMandatory = Object.keys(JSON.parse(self.getAllQuestionList).survey.questionslist_ismandatory)
				// 	var getQuestMandatorylength = getQuestMandatory.length
				// 	if(getQuestMandatorylength > 0)
				// 	{
				// 		var setgetQuestMandatory =[];
				// 		for (var qans in getQuestMandatory) 
				// 		{
				// 			setgetQuestMandatory.push(getQuestMandatory[qans].split('_')[1]);
				// 		}
	
				// 		// const commonElements = surveyquesvalInarry.filter(secondElement => 
				// 		// 	setgetQuestMandatory.some(firstElement => firstElement.name === secondElement.name))
	
	
				// 		// var quesAnsResult = 0
				// 		// let checker = (arr, target) => target.some(v => arr.includes(v));
				// 		// var ischeckervalid = checker(setgetQuestMandatory, surveyquesvalInarry);
	
				// 		// var getvaluesMand =surveyquesvalInarry.some(ele => setgetQuestMandatory.includes(ele))
				// 		surveyquesvalInarry = surveyquesvalInarry.sort();
				// 		setgetQuestMandatory = setgetQuestMandatory.sort(); // required mandatory list s
				// 		//var arrsystring = _.isEqual(surveyquesvalInarry,setgetQuestMandatory);
				// 		var arrsystring = !setgetQuestMandatory.some(ele => !surveyquesvalInarry.includes(ele)) 
				// 		if(arrsystring === false){
				// 			$("#in-modal-btnsubmit").click();
				// 			return false;
				// 		}
				// 	}
				// }
	
				// option -2 
				if(self.getAllQuestionList)
				{
					var surveyquesval = document.getElementsByName("surveyquestionans").value ;
					var surveyquesvalInarry = surveyquesval ? Object.keys(surveyquesval) : [];
					var getQuestMandatory = Object.keys(JSON.parse(self.getAllQuestionList).survey.questionslist_ismandatory)
					var getQuestMandatorylength = getQuestMandatory.length
					if(getQuestMandatorylength > 0)
					{
						var setgetQuestMandatory =[];
						for (var qans in getQuestMandatory) 
						{
							setgetQuestMandatory.push(getQuestMandatory[qans].split('_')[1]);
						}
	
						// const commonElements = surveyquesvalInarry.filter(secondElement => 
						// 	setgetQuestMandatory.some(firstElement => firstElement.name === secondElement.name))
	
	
						// var quesAnsResult = 0
						// let checker = (arr, target) => target.some(v => arr.includes(v));
						// var ischeckervalid = checker(setgetQuestMandatory, surveyquesvalInarry);
	
						// var getvaluesMand =surveyquesvalInarry.some(ele => setgetQuestMandatory.includes(ele))
						surveyquesvalInarry = surveyquesvalInarry.sort();
						setgetQuestMandatory = setgetQuestMandatory.sort(); // required mandatory list s
						//var arrsystring = _.isEqual(surveyquesvalInarry,setgetQuestMandatory);
						// var arrsystring = !setgetQuestMandatory.some(ele => !surveyquesvalInarry.includes(ele)) 
						// if(arrsystring === false){
						// 	$("#in-modal-btnsubmit").click();
						// 	return false;
						// }
						var erroglag = true;
						var Newarrsystring = setgetQuestMandatory.filter(function(obj) { return surveyquesvalInarry.indexOf(obj) == -1; });
							Newarrsystring.forEach((element) => {
							console.log(element);
							erroglag = false;
							const getlay= self.options.container.layout;		
							const global_view_message = new MessageView({
								message: Utils.translate('This field is required.'),
								type: 'error',
								closable: true
							});					
	
							getlay.$('[data-type="alert-placeholder-message-question-answer-type-set-validation-unique-'+element+'"]').html(global_view_message.render().$el.html());
							const confirmation_message = getlay.$('[data-type="alert-placeholder-message-question-answer-type-set-validation-unique-'+element+'"]').css("display","block");
							setTimeout(function() {
								confirmation_message.fadeOut(3000);
							}, 5000);
						});
	
						if(erroglag ==false)
						{
							return erroglag;
						}
					}
				}
	
	
	
				var cart = self.options.container.getComponent('Cart');
				var _itemId = self.options.pdp.item.internalid;
					self.parentItemId = self.options.pdp.item.internalid;
				var getmultiPriceOption = jQuery('input[name="multiPriceOption"]:checked').val();
				if(getmultiPriceOption){
					_itemId = getmultiPriceOption;
				}
				self.newitemid = _itemId;
				var lines = cart.getLines();
				var indexed = true;
				lines.then(function(lines,) {
					for (i=0; i < lines.length; i++) {
						var getitemid = lines[i].item.internalid;
						//var getname = lines[i].options !=0 ? lines[i].options.filter(val => val.cartOptionId =='custcol_event_register_name')[0].value.internalid : '';
						var getemail = lines[i].options !=0 ? lines[i].options.filter(val => val.cartOptionId =='custcol_nus_ems_patemail')[0] : '';
							getemail = getemail ? getemail.value.internalid : '';
						if(getitemid == _itemId && getemail ==  form_data.nus_email_address)
						{
							indexed = false;
						}					
					}
				}).then(function() {
						if(indexed)
						{
							if(form_data){
								self.addCompName = jQuery("#in-modal-mysearchCompany").val().trim();
								form_data.nus_regstype = self.options.addNewColleague;
								form_data.nus_ems_item = self.newitemid; //self.options.pdp.item.internalid;
								form_data.parentItemId = self.parentItemId;
								//form_data.mysearchCompany = document.querySelector("#in-modal-searchCompany"  + " option[value='" + jQuery("#in-modal-mysearchCompany").val().trim() + "']").dataset.value;
								form_data.mysearchCompany = self.getorgID;
								if(document.getElementsByName("surveyquestionans").value)
								{
									form_data.folderid = SC.CONFIGURATION.MyRegisterColleague.pdpquestionfolderidmapping;
									form_data.surveyquestionans = JSON.stringify(Object.values(document.getElementsByName("surveyquestionans").value));
								}
								
								if("NewColleaguelist" == self.options.addNewColleague)
								{
									self.addTicketEventWithoutRecord('',form_data)
	
									if(self.isduplicateEvent_responce.length > 0)
									{
										const getlay= self.options.container.layout;		
										const global_view_message = new MessageView({
											message: SC.CONFIGURATION.MyRegisterColleague.config || Utils.translate(self.isduplicateEvent_responce[0].retrunMesgError),
											type: 'error',
											closable: true
										});				
										getlay.$('[data-type="alert-placeholder-common-message"]').html(global_view_message.render().$el.html());
	
									}
									else{
										if(self.isperson != true)
											{
												jQuery('.class-waitlist-confirmation-message').css('display','none');
												jQuery(".reg-add-to-disaply-multiple-event").css("display","block");
												jQuery(".reg-add-to-disaply").css("display","none");
											}	
									}							
	
									//self.addTicketEvent(response,form_data);
								}
								else{
									var model = new MyRegisterColleagueSS2Model();      
										model.fetch({
										async: false,
										type: 'POST',
										data: {data:JSON.stringify(form_data)},
									})
									.done(function (response) { 
										if(response.errorMessage !='')
										{
											// const getlay= self.options.container.layout;		
											// const global_view_message = new MessageView({
											// 	message: SC.CONFIGURATION.MyRegisterColleague.config || Utils.translate(response.errorMessage[0].retrunMesgError),
											// 	type: 'error',
											// 	closable: true
											// });				
											// getlay.$('[data-type="alert-placeholder-common-message"]').html(global_view_message.render().$el.html());

											var errormessage = '';

											if(response.errorMessage && typeof response.errorMessage === 'string'){
												errormessage = response.errorMessage;
											}
											else if(response.errorMessage[0].retrunMesgError && Array.isArray(response.errorMessage)){
												errormessage = response.errorMessage[0].retrunMesgError;
											}
											else{
												errormessage = SC.CONFIGURATION.MyRegisterColleague.config;
											}
											const getlay= self.options.container.layout;		
											const global_view_message = new MessageView({
												message: Utils.translate(errormessage),
												type: 'error',
												closable: true
											});				
											getlay.$('[data-type="alert-placeholder-common-message"]').html(global_view_message.render().$el.html());
										
											
										}
										else if(self.options.addNewColleague == "Waitlist"){
											jQuery(".reg-add-to-disaply").css("display","none");
											jQuery(".reg-add-to-disaply-multiple-event").css("display","none");
											jQuery('.class-waitlist-confirmation-message').css('display','block');
											jQuery('.waitlisttitle').text(self.options.pdp.item.displayname);
											jQuery('.waitlistname').text(response.nus_ems_name);
											jQuery('.waitlistemail').text(response.nus_email_address);
											jQuery(".waitlisttitleconfirm").text('WAITLIST CONFIRMATION');
											jQuery(".waitlistdetailsheading").text("WAITLIST DETAILS");
											jQuery(".msgfromorg").text("If a ticket becomes available, you will be contacted automatically with further instructions on how to purchase your ticket. No further action is required.");
											jQuery(".logodetails").text('You are on the waitlist!');
										}
										else if(self.options.addNewColleague == "scrrequire"){
											jQuery(".reg-add-to-disaply").css("display","none");
											jQuery(".reg-add-to-disaply-multiple-event").css("display","none");
											jQuery('.class-waitlist-confirmation-message').css('display','block');
											jQuery('.waitlisttitle').text(self.options.pdp.item.displayname);
											jQuery('.waitlistname').text(response.nus_ems_name);
											jQuery('.waitlistemail').text(response.nus_email_address);
											jQuery(".waitlisttitleconfirm").text('We have received your registration!');
											jQuery(".waitlistdetailsheading").text("REGISTRATION  DETAILS");
											//jQuery(".msgfromorg").text("If Your Application is approved, You will be contacted with further instructions.");
											jQuery(".msgfromorg").text("Thank you for your interest. We will inform you of the outcome of your registration once it has been reviewed.");
											jQuery(".logodetails").text('Your Registration is Submitted');
	
	
											var $return_header = $('.myregistercolleague-info-card-content').first().collapse('show');
												jQuery('html, body').animate(
												{
													scrollTop: $return_header.offset().top
												},
												500
											);
										}
										else{
											// if(self.isperson != true)
											// {
											// 	jQuery('.class-waitlist-confirmation-message').css('display','none');
											// 	jQuery(".reg-add-to-disaply-multiple-event").css("display","block");
											// 	jQuery(".reg-add-to-disaply").css("display","none");
											// }									
											// self.addTicketEvent(response,form_data);
										}
									});
								}						
							}		
						}
						else{
							const getlay= self.options.container.layout;		
							const global_view_message = new MessageView({
								message: Utils.translate('You have already selected this event. Please check the cart.'),
								type: 'error',
								closable: true
							});					
	
							getlay.$('[data-type="alert-placeholder-common-message"]').html(global_view_message.render().$el.html());
							const confirmation_message = getlay.$('[data-type="alert-placeholder-common-message"]').css("display","block");
	
							setTimeout(function() {
								confirmation_message.fadeOut(3000);
							}, 5000);
	
							return false;
						}
				});		 
			}
		
		,	resetformclear : function()
			{
				var self = this;		  	
				// jQuery('#in-modal-mysearchCompany').val('');
				// jQuery("#in-modal-searchCompany").empty('');
				// jQuery('#in-modal-contact_list').find('option').not(':first').remove();
				jQuery('#in-modal-contact_list').val('');
				jQuery('#in-modal-nus_ems_name').val('');
				jQuery('#in-modal-nus_job_title').val('')
				jQuery('#in-modal-nus_phone_no').val('')
				jQuery('#in-modal-nus_email_address').val('')
			}
		,	addTicketEvent : function(param,form_data)
			{
				var self = this;				
				var cart = self.options.container.getComponent('Cart');
				var _itemId = self.options.pdp.item.internalid;
				var getmultiPriceOption = jQuery('input[name="multiPriceOption"]:checked').val();
				if(getmultiPriceOption){
					_itemId = getmultiPriceOption;
				}
				var cardEventAdded =	cart.addLines({
						lines:  [
							{
								quantity: 1,
								options:[
									{	cartOptionId:"custcol_ref_participant_record",value:{internalid: param.cid+""}},
									{   cartOptionId:"custcol_event_register_name",value:{internalid: param.nus_ems_name }},
									{   cartOptionId:"custcol_nus_ems_patemail",value:{internalid: param.nus_email_address }},
									{   cartOptionId:"custcol_nus_ems_partcomp",value:{internalid: self.addCompName }},
									{   cartOptionId:"custcol_nus_ems_participant",value:{internalid: JSON.stringify(form_data) }},
								],
								item: {
									internalid: _itemId,
								},
								price:"12",						
							},							
						]
				}).then(function() {
					if(self.isperson == true)
					{
						document.getElementById("in-modal-custom-btn-goto-cart").click();
					}
				});
			}
	
		,	getduplicateEventList: function(_itemId,form_data)
			{
				var self = this;		 
				self.isduplicateEvent_responce = [];
				if(_itemId !=""){ 	
					var model = new MyRegisterColleagueSS2Model();      
						model.fetch({async: false,data: {
						'nus_ems_item': _itemId,
						'contact_list':form_data.contact_list,
						'nus_email_address':form_data.nus_email_address,
						'getmethod':'getduplicateEventList'
					},
				}).done(function (response) { 					
						self.isduplicateEvent_responce = response;
					});
				}
			}
	
		,	getDocumentUploadEventId: function(_itemId,form_data)
			{
				var self = this;		 
					self.isDocumentUploadEvent_responce = [];
				if(_itemId !=""){ 	
					var model = new MyRegisterColleagueSS2Model();      
						model.fetch({ type: 'POST',async: false,data: {
						'itemid': _itemId,
						'data':''+ JSON.stringify(jQuery(form_data)[0]),
						'folderid' : SC.CONFIGURATION.MyRegisterColleague.pdpquestionfolderid,
						'getmethod':'getDocumentUploadEvent'
					},
				}).done(function (getresponse) { 					
						self.isDocumentUploadEvent_responce = getresponse;
					});
				}
			}
	
		,	addTicketEventWithoutRecord : function(param,form_data)
			{
				var self = this;				
				var cart = self.options.container.getComponent('Cart');
				var _itemId = self.options.pdp.item.internalid;
				var getmultiPriceOption = jQuery('input[name="multiPriceOption"]:checked').val();
				if(getmultiPriceOption){
					_itemId = getmultiPriceOption;
				}
	
				self.isduplicateEvent_responce_1 = self.getduplicateEventList(_itemId,form_data);
				self.isDocumentUploadEvent_responce_2 = self.getDocumentUploadEventId(_itemId,form_data);
	
					if(self.isduplicateEvent_responce.length > 0)
					{
						return self.isduplicateEvent_responce;
					}
					else{
						if(self.isDocumentUploadEvent_responce.id !=''){
							form_data.surveyquestionans = self.isDocumentUploadEvent_responce.id;
						}
						self.get_ems_cart_ref = self.isDocumentUploadEvent_responce.get_ems_cart_ref ? self.isDocumentUploadEvent_responce.get_ems_cart_ref : form_data; 

						var cardEventAdded = cart.addLines({
							lines:  [
								{
									quantity: 1,
									options:[
										{	cartOptionId:"custcol_ref_participant_record",value:{internalid: ''}},
										{   cartOptionId:"custcol_event_register_name",value:{internalid: form_data.nus_ems_name }},
										{   cartOptionId:"custcol_nus_ems_patemail",value:{internalid: form_data.nus_email_address }},
										{   cartOptionId:"custcol_nus_partjobtitle",value:{internalid: form_data.nus_job_title }},
										{   cartOptionId:"custcol_nus_partphonno",value:{internalid: form_data.nus_phone_no }},
										{   cartOptionId:"custcol_nus_ems_participant",value:{internalid: JSON.stringify(self.get_ems_cart_ref) }},
										{   cartOptionId:"custcol_nus_ems_partcomp",value:{internalid: self.addCompName }},
									],
									item: {
										internalid: _itemId,
									},
									price:"12",						
								},							
							]
					}).then(function() {
						if(self.isperson == true)
						{
							document.getElementById("in-modal-custom-btn-goto-cart").click();
						}
					});
				}		
			}
	
			,	getIsTicketEvent : function(param)
			{
				var self = this;				
				var cart = self.options.container.getComponent('Cart');
				var _itemId = self.options.pdp.item.internalid;
				var getmultiPriceOption = jQuery('input[name="multiPriceOption"]:checked').val();
				if(getmultiPriceOption){
					_itemId = getmultiPriceOption;
				}
				var lines = cart.getLines();
				var indexed = false;
				
				lines.then(function(lines,) {
					for (i=0; i < lines.length; i++) {
						var getitemid = lines[1].item.internalid;
						var getname = lines[i].options !=0 ? lines[i].options.filter(val => val.cartOptionId =='custcol_event_register_name')[0] : '';
							getname = getname ? getname.value.internalid : '';
	
						if(getitemid == _itemId && getname ==  param)
						{
							indexed = true;
						}					
					}
				}).then(function() {
						if(true)
						{
	
						}
				});
	
				return indexed;
			}
	
		,	searchAndGetListCompany: function(e)
			{
				var profile = ProfileModel.getInstance();
				var is_loged_in = profile.get('isLoggedIn') === 'T';
				var mult_email = '';
				if(e == undefined)
				{
					var getsearchkeyword = is_loged_in == true ? profile.get('companyname') : '';
				}
				else{
					e.preventDefault();
					if(this.options.pdp.item.custitem_nus_ems_addguest)
					{
						var getsearchkeyword = this.$(e.currentTarget).val() || '';
					}
					else{
						var getsearchkeyword = is_loged_in == true ? profile.get('companyname') : '';
					}
				}
	
				if(is_loged_in == true && profile.get('isperson'))
				{
					var getsearchkeyword = profile.get('name') || '';
				}
	
				mult_email = is_loged_in == true ? profile.get('email') : '';
				var loginID = is_loged_in == true ? profile.get('internalid') : '';
	
				var self = this;		  	
					self.getAllQuestionList = '';
					jQuery("#in-modal-searchCompany").empty('');
			
				if(getsearchkeyword.length > 2){
					var model = new MyRegisterColleagueSS2Model();      
						model.fetch({async: false,data: {
						'getsearchkeyword': ""+getsearchkeyword,
						'mult_email':mult_email,
						'loginID' : loginID,
						'getmethod':'companyListSearching'
					}})
					.done(function (response) { 
						var _searchCompanyappend ="";
						jQuery("#in-modal-searchCompany").empty('');
						if(response.length > 0)
						{
							self.searchCompany = response;
							for(var n=0;n<response.length; n++)
							{
								_searchCompanyappend += '<option  data-value="'+response[n].internalid+'"    value="'+response[n].name+'">';
							}       
						}
	
						jQuery("#in-modal-searchCompany").append(_searchCompanyappend);
					});
				}		 
			}
	
		,	ContactListSearching: function(e,param)
			{
				//e.preventDefault();
				var self = this;	
				var getsearchkeyword ='';	  	
				jQuery('#in-modal-contact_list').find('option').not(':first').remove();
				jQuery('#in-modal-nus_ems_name').val('');
				jQuery('#in-modal-nus_job_title').val('');
				jQuery('#in-modal-nus_phone_no').val('');
				jQuery('#in-modal-nus_email_address').val('');
				// if(jQuery("#in-modal-mysearchCompany").val())
				// {
				// 	getsearchkeyword = document.querySelector("#in-modal-searchCompany"  + " option[value='" + jQuery("#in-modal-mysearchCompany").val().trim() + "']").dataset.value;
				// }
	
				getsearchkeyword = param ? param : jQuery("#in-modal-mysearchCompany").val();
				if(getsearchkeyword !=""){
					var model = new MyRegisterColleagueSS2Model();      
						model.fetch({async: false,data: {
						'getsearchkeyword': ""+getsearchkeyword,
						'types':'company',
						'allowregother':self.options.pdp.item.custitem_nus_ems_regother,
						'allowaddguest':self.options.pdp.item.custitem_nus_ems_addguest,
						'getmethod':'ContactListSearching',
						"doyouwanttoaddmore":doyouwanttoaddmore
					}})
					.done(function (response) { 	
						var contactlistappend ="";				
						if(response)
						{
							self.ContactList = response;
							for(var n=0;n<response.length; n++)
							{
								contactlistappend += '<option value="'+response[n].internalid+'" >'+response[n].name+'</option>';
							}        
						}
						jQuery("#in-modal-contact_list").append(contactlistappend);
					});
				}		 
			}
	
		,	get_all_question_list: function(param)
			{
				var self = this;		 
				if(param !=""){ 	
					var model = new MyRegisterColleagueSS2Model();      
						model.fetch({async: false,data: {
						'getsearchkeyword': ""+param,
						'getmethod':'getAllQuestionListDisplay'
					},
				})
					.done(function (response) { 					
						self.getAllQuestionList = response;
					});
				}
			}
	
		,	multiPriceOption: function(param)
			{
				var self = this;		
				self.getmultiPriceOption = [];
				var skuname = self.pdp.getItemInfo() ?	self.pdp.getItemInfo().item.internalid : '';
				if(skuname !=""){ 	
					var model = new MyRegisterColleagueSS2Model();      
						model.fetch({async: false,data: {
						'skuname': skuname,
						'getmethod':'getmultiPriceOption'
					},
				})
					.done(function (response) { 					
						self.getmultiPriceOption = response;
						this.getmultiPriceOption = response;
					});
				}
			}
	
		// ,	getIsReleaseWaitlist: function(param)
		// 	{
		// 		var self = this;		
		// 		self.resultgetIsReleaseWaitlist = [];
		// 		var skuname = self.pdp.getItemInfo() ?	self.pdp.getItemInfo().item.internalid : '';
		// 		if(skuname !=""){ 	
		// 			var model = new MyRegisterColleagueSS2Model();      
		// 				model.fetch({async: false,data: {
		// 				'skuname': skuname,
		// 				'getmethod':'getIsReleaseWaitlist'
		// 			},
		// 		})
		// 			.done(function (response) { 					
		// 				self.resultgetIsReleaseWaitlist = response;
		// 			});
		// 		}
		// 	}
	
		,	bindings: {
	
			}
	
		, 	childViews: {
	
			}
	
			//@method getContext @return NVT.MyRegisterColleague.MyRegisterColleague.View.Context
		,	getContext: function getContext()
			{
				var self = this;				
				const profile = ProfileModel.getInstance();
				const is_loged_in = profile.get('isLoggedIn') === 'T';
				
				if(is_loged_in)
				{
					localStorage.removeItem('savedFragment');
				}
				else{
					const fragment = window.location.href;
					localStorage.setItem("savedFragment", fragment);
				}
	
				if(is_loged_in && this.inModal)
				{
					self.searchAndGetListCompany();
					self.ContactListSearching('',profile.get('internalid'));
	
					var getContactName = [];
	
					if(self.ContactList){
						getContactName = self.ContactList.filter(function(contact_list) {
							return contact_list.isSelected == 'T'
						});
					}
	
					if(getContactName.length > 0)
					{
						self.getContactName = getContactName[0].name;
						self.getJobTitle = getContactName[0].getJobTitle;
						self.getPhoneNo = getContactName[0].getPhoneNo;
						self.getEmailAddress = getContactName[0].getEmailAddress;
					}
	
					if(self.options.pdp)
					{
						self.get_all_question_list(self.options.pdp.item.internalid);
					}
				}
					
				var response = ''
				if(self.getAllQuestionList)
				{
					var debugindex = self.getAllQuestionList.lastIndexOf('}')+1;
					var response = JSON.parse(self.getAllQuestionList.substr(0,debugindex)).survey;
				}
					
				var getpriceoption =  self.multiPriceOption();
				//var ReleaseWaitlist = self.getIsReleaseWaitlist();
				
				// if(this.options.addNewColleague == 'Waitlist')
				// {
				// 	response = '';
				// }
				return {
					questionslist_ismandatory : response ? encodeURIComponent( JSON.stringify(response.questionslist_ismandatory)) : '',
					survey:  response,
					isInModal : this.inModal,
					is_loged_in : is_loged_in,
					searchCompanyname: profile.get('companyname') || profile.get('firstname') + ' ' +  profile.get('lastname'),
					searchCompanyList : self.searchCompany || [],
					ContactList : self.ContactList || [],
					getContactName: self.getContactName || '',
					getJobTitle : self.getJobTitle || '',
					getPhoneNo : self.getPhoneNo || '',
					getEmailAddress : self.getEmailAddress,
					ems_emsebdate :  this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.custitem_nus_ems_emsebdate : '' ,
					getpriceLevel1 : this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.pricelevel2_formatted : '' ,
					getpriceLevel2 : this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.pricelevel3_formatted : '' ,
					getpriceLevel3 : this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.pricelevel5_formatted : '' ,
					getpriceLevel4 : this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.pricelevel12_formatted : '' ,
					getmultiPriceOption : self.getmultiPriceOption,
					registerColleaguetrue :  this.getcurrentindexval ? this.getcurrentindexval == '2' ? true : false : true,
					registerColleaguefalse :  this.getcurrentindexval == '1' ? true : false,
					ems_regother : self.options.pdp ? self.options.pdp.item.custitem_nus_ems_regother ? true :false  : false,
					ems_addguest : self.options.pdp ? self.options.pdp.item.custitem_nus_ems_addguest ||  self.options.pdp.item.custitem_nus_ems_regother ? true : false : false,
					isRegistrationclosed : this.pdp.getItemInfo() ?  this.pdp.getItemInfo().item.custitem_nus_ems_approval_status_ev == 'Approved' ? false : true : false,
					isRegistrationclosedShowJoinWaitlist : this.pdp.getItemInfo() ?  this.pdp.getItemInfo().item.custitem_nus_ems_approval_status_ev == 'Registration Closed' && this.pdp.getItemInfo().item.custitem_nus_iswaitliston == true? true : false : false,
					ems_approval_status_ev : this.pdp.getItemInfo() ?  this.pdp.getItemInfo().item.custitem_nus_ems_approval_status_ev : '',
					nus_ems_cutmessage : this.pdp.getItemInfo() ?  this.pdp.getItemInfo().item.custitem_nus_ems_cutmessage : '',
					addNewColleagueOption : this.options.addNewColleague == 'Waitlist' ? true : false	,
					nus_ems_exteurl : this.pdp.getItemInfo() ?  this.pdp.getItemInfo().item.custitem_nus_ems_exteurl : '',
					nus_iswaitliston : this.pdp.getItemInfo() ?  this.pdp.getItemInfo().item.custitem_nus_iswaitliston : false,
					isbtnshowPTRN : this.pdp.getItemInfo() ?  this.pdp.getItemInfo().item.custitem_nus_ems_approval_status_ev == 'Approved' &&  this.pdp.getItemInfo().item.custitem_nus_iswaitliston != true ? true : false : false,
					//releaseWaitlist : self.resultgetIsReleaseWaitlist.length > 0 ? true : false,
					isscrrequire : this.pdp.getItemInfo() ?  this.pdp.getItemInfo().item.custitem_nus_ems_scrrequire : false,
					titleName:  this.options.title || '',
					ispersonshow: profile.get('isperson') === true,
					isgetnoneditblecontact : this.options.isgetnoneditblecontact === true,
					modelscrrequire :this.options.addNewColleague == 'scrrequire' ? true : false,
				}
			}
		});
	});
	
